import Trigger from './Trigger';

export type { TriggerProps } from './Trigger';

export default Trigger;
